<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-users"></Navbar>

    <div class="container-fluid py-4">
      <!-- ===== PAGE HEADER ===== -->
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
        <div class="d-flex align-items-center">
          <div class="cw-header-icon mr-3" style="background:linear-gradient(135deg,#F7931E,#E07B00);">
            <i class="ti-user" style="color:#fff;font-size:1.5rem;"></i>
          </div>
          <div class="text-left">
            <h3 class="mb-0 font-weight-bold text-dark">Gestione Utenti</h3>
            <p class="mb-0 text-muted small">Gestisci utenti della piattaforma e operatori sul campo</p>
          </div>
        </div>

        <!-- Main section tabs -->
        <div class="cw-location-tabs mx-auto" style="min-width: 400px; background: #e2e8f0; padding: 4px; border-radius: 12px;" v-if="mode === 'list'">
          <button type="button" class="cw-loc-tab" style="flex: 1; padding: 10px; font-size: 0.8rem; flex-direction: row; gap: 6px;" @click="$router.push({name: 'admin-users'})">
            <i class="mdi mdi-account-group mr-1" style="font-size: 1.1rem;"></i> Backoffice
          </button>
          <button type="button" class="cw-loc-tab active" style="flex: 1; padding: 10px; font-size: 0.8rem; box-shadow: 0 2px 8px rgba(0,0,0,0.08); flex-direction: row; gap: 6px;">
            <i class="mdi mdi-account-hard-hat mr-1" style="font-size: 1.1rem;"></i> Operatori sul Campo
          </button>
        </div>

        <button
          v-if="mode === 'list'"
          class="cw-btn-submit"
          @click="setAddMode()"
        >
          <i class="mdi mdi-account-plus mr-1"></i> Aggiungi Operatore
        </button>
        <button
          v-else
          class="btn btn-light btn-sm rounded-pill px-4 font-weight-semibold border"
          @click="mode = 'list'"
        >
          <i class="mdi mdi-arrow-left mr-1"></i> Torna alla lista
        </button>
      </div>

      <!-- ===== LIST MODE ===== -->
      <div v-if="mode === 'list'">
        <div class="au-card">
          <div class="cw-section-title">
            Elenco Operatori
          </div>

          <!-- Search + Filters -->
          <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
            <!-- Search -->
            <div class="au-search-wrap">
              <i class="mdi mdi-magnify au-search-icon"></i>
              <input
                v-model="searchQuery"
                class="au-search-input"
                placeholder="Cerca per nome, cognome o qualifica.."
              >
            </div>
            <!-- Filter tabs -->
            <div class="cw-location-tabs" style="min-width: 260px;">
              <button type="button" class="cw-loc-tab" :class="{ active: teamFilter === 'ALL' }" @click="teamFilter = 'ALL'">
                <span>Tutti</span>
              </button>
              <button type="button" class="cw-loc-tab" :class="{ active: teamFilter === 'TEAMS' }" @click="teamFilter = 'TEAMS'">
                <span>Solo squadre</span>
              </button>
            </div>
          </div>

          <!-- Grouped Operators View -->
          <div v-if="hasResults">
            <div
              v-for="(group, gIndex) in filteredGroups"
              :key="group.team ? 'team-' + group.team.id : (group.isUnassigned ? 'unassigned' : 'auto-' + gIndex)"
              class="au-group mb-4"
            >
              <!-- Group header -->
              <div class="au-group-header d-flex align-items-center justify-content-between flex-wrap" style="gap:10px;">
                <div class="d-flex align-items-center" style="gap:12px;">
                  <div class="au-avatar" :class="group.isUnassigned ? 'au-avatar-admin' : 'au-avatar-squad'">
                    <i class="mdi" :class="group.isUnassigned ? 'mdi-account-question-outline' : 'mdi-account-group'"></i>
                  </div>
                  <div class="text-left">
                    <div class="d-flex align-items-center" style="gap:8px;">
                      <span class="font-weight-bold text-dark" style="font-size:0.98rem;">
                        <template v-if="group.isUnassigned">Senza squadra</template>
                        <template v-else-if="group.team">{{ group.team.fullname || group.team.team_name }}</template>
                        <template v-else>{{ group.header }}</template>
                      </span>
                      <span v-if="group.isAutonomous" class="au-role-badge au-role-squad">Autonomo</span>
                    </div>
                    <small class="text-muted" style="font-size:0.78rem;">
                      {{ group.operators.length }} {{ group.operators.length === 1 ? 'operatore' : 'operatori' }}
                    </small>
                  </div>
                </div>

                <!-- Group actions (only for real squads, never for Gruppo_Senza_Squadra) -->
                <div v-if="!group.isUnassigned && group.team" class="d-flex align-items-center" style="gap:8px;">
                  <button class="au-btn-action" @click="openAssignModal(group.team)">
                    <i class="mdi mdi-account-multiple-plus-outline mr-1"></i> Assegna operatori
                  </button>
                  <button class="au-btn-action" @click="goToBackoffice(group.team)">
                    <i class="mdi mdi-cog-outline mr-1"></i> Modifica squadra
                  </button>
                </div>
              </div>

              <!-- Empty squad placeholder -->
              <div v-if="group.operators.length === 0 && !group.isUnassigned" class="au-group-empty text-muted text-center py-4">
                <i class="mdi mdi-account-off-outline mr-1"></i> Nessun operatore assegnato
              </div>

              <!-- Members table -->
              <div v-else class="table-responsive">
                <table class="au-table">
                  <thead>
                    <tr>
                      <th>Operatore</th>
                      <th>Qualifica</th>
                      <th>Telefono / Email</th>
                      <th>Costo Orario</th>
                      <th>Tipo</th>
                      <th>Stato</th>
                      <th class="text-right">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in group.operators" :key="item.id">
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="au-avatar mr-3" :class="item.is_autonomo ? 'au-avatar-squad' : 'au-avatar-admin'">
                            <i class="mdi" :class="item.is_autonomo ? 'mdi-account-hard-hat' : 'mdi-account-outline'"></i>
                          </div>
                          <div>
                            <span class="font-weight-bold text-dark d-block">{{ item.cognome }} {{ item.nome }}</span>
                            <small class="text-muted" style="font-size:0.75rem;">CF: {{ item.codice_fiscale || '-' }}</small>
                          </div>
                        </div>
                      </td>
                      <td class="font-weight-semibold text-dark">{{ item.qualifica || '-' }}</td>
                      <td>
                        <div style="font-size: 0.8rem;">
                          <span class="d-block text-dark" v-if="item.telefono"><i class="mdi mdi-phone-outline mr-1 text-muted"></i>{{ item.telefono }}</span>
                          <span class="text-muted" v-if="item.email"><i class="mdi mdi-email-outline mr-1"></i>{{ item.email }}</span>
                        </div>
                      </td>
                      <td>
                        <span class="font-weight-bold text-dark" v-if="item.costo_orario">{{ item.costo_orario }} €/h</span>
                        <span class="text-muted" v-else>-</span>
                      </td>
                      <td>
                        <span v-if="item.is_autonomo" class="au-role-badge au-role-squad">
                          Autonomo
                        </span>
                        <span v-else class="au-role-badge au-role-admin">
                          Membro Squadra
                        </span>
                      </td>
                      <td>
                        <span :class="item.is_attivo ? 'badge-status-active' : 'badge-status-inactive'">
                          {{ item.is_attivo ? 'Attivo' : 'Inattivo' }}
                        </span>
                      </td>
                      <td class="text-right">
                        <button class="au-btn-action mr-2" @click="setEditMode(item)">
                          <i class="mdi mdi-pencil-outline mr-1"></i> Gestisci
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Global empty state -->
          <div v-else class="text-center py-5 text-muted">
            <i class="mdi mdi-account-search mdi-48px d-block mb-2"></i>
            Nessun operatore trovato
          </div>
        </div>
      </div>

      <!-- ===== ASSIGN OPERATORS MODAL ===== -->
      <div v-if="assignModalOpen" class="au-modal-overlay" @click.self="closeAssignModal">
        <div class="au-modal">
          <div class="au-card">
            <div class="cw-section-title">
              <span class="cw-step-num"><i class="mdi mdi-account-multiple-plus-outline" style="font-size:0.75rem;"></i></span>
              Assegna operatori — {{ assignTargetTeam ? (assignTargetTeam.fullname || assignTargetTeam.team_name) : '' }}
            </div>

            <div class="au-modal-body">
              <p v-if="assignCandidates.length === 0" class="text-muted text-center py-4">
                Nessun operatore disponibile per questa azienda.
              </p>
              <label
                v-for="cand in assignCandidates"
                :key="cand.id"
                class="au-checkbox-label mb-2"
              >
                <input
                  type="checkbox"
                  class="au-checkbox-input"
                  :value="cand.id"
                  v-model="assignSelectedIds"
                >
                <span class="au-checkbox-custom"></span>
                <span class="d-flex flex-column text-left">
                  <span class="font-weight-bold">{{ cand.cognome }} {{ cand.nome }}</span>
                  <small class="text-muted" style="font-size:0.72rem;">{{ cand.qualifica || 'Operatore' }}</small>
                </span>
              </label>
            </div>

            <div class="cw-footer mt-4 d-flex align-items-center justify-content-end flex-wrap" style="gap:12px;">
              <button type="button" class="btn btn-light rounded-pill px-4 font-weight-semibold border" @click="closeAssignModal" :disabled="assignSaving">
                Annulla
              </button>
              <button type="button" class="cw-btn-submit" @click="saveAssignment" :disabled="assignSaving">
                <i class="mdi mdi-check-circle-outline mr-1"></i>
                {{ assignSaving ? 'Salvataggio...' : 'Salva' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== ADD / EDIT MODE ===== -->
      <div v-if="mode === 'add' || mode === 'edit'">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-8">
            <div class="au-card">
              <div class="cw-section-title">
                <span class="cw-step-num">{{ mode === 'add' ? '+' : '✏️' }}</span>
                {{ mode === 'add' ? 'Nuovo Operatore' : 'Gestisci Operatore' }}
              </div>

              <form @submit.prevent="saveOperator">
                <div class="row">
                  <!-- Nome -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Nome <span class="text-danger">*</span></label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-account-outline cw-field-icon"></i>
                      <input v-model="operator.nome" class="cw-input" placeholder="Nome" required @input="updateUsernamePreview">
                    </div>
                  </div>

                  <!-- Cognome -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Cognome <span class="text-danger">*</span></label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-account-outline cw-field-icon"></i>
                      <input v-model="operator.cognome" class="cw-input" placeholder="Cognome" required @input="updateUsernamePreview">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- Codice Fiscale -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Codice Fiscale</label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-card-account-details-outline cw-field-icon"></i>
                      <input v-model="operator.codice_fiscale" class="cw-input" placeholder="Codice Fiscale" maxlength="16" style="text-transform: uppercase;">
                    </div>
                  </div>

                  <!-- Qualifica -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Qualifica / Ruolo</label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-briefcase-outline cw-field-icon"></i>
                      <input v-model="operator.qualifica" class="cw-input" placeholder="Es. Caposquadra, Autore, Tecnico">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- Telefono -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Telefono</label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-phone-outline cw-field-icon"></i>
                      <input v-model="operator.telefono" class="cw-input" placeholder="Numero di telefono">
                    </div>
                  </div>

                  <!-- Email -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Email</label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-email-outline cw-field-icon"></i>
                      <input v-model="operator.email" class="cw-input" type="email" placeholder="email@esempio.it">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- Costo Orario -->
                  <div class="col-md-6 form-group mb-4 text-left">
                    <label class="cw-label">Costo Orario (€/ora)</label>
                    <div class="cw-input-wrap">
                      <i class="mdi mdi-currency-eur cw-field-icon"></i>
                      <input v-model="operator.costo_orario" class="cw-input" type="number" step="0.01" min="0" placeholder="Es. 25.00">
                    </div>
                  </div>

                  <!-- Stato Attivo -->
                  <div class="col-md-6 form-group mb-4 d-flex align-items-center text-left" style="padding-top: 28px;">
                    <label class="au-checkbox-label" for="op_attivo">
                      <input
                        type="checkbox"
                        class="au-checkbox-input"
                        id="op_attivo"
                        v-model="operator.is_attivo"
                      >
                      <span class="au-checkbox-custom"></span>
                      Operatore Attivo
                    </label>
                  </div>
                </div>

                <!-- Azienda (developer only) -->
                <div class="form-group mb-4 text-left" v-if="isDeveloper">
                  <label class="cw-label">Azienda <span class="text-danger">*</span></label>
                  <div class="cw-select-wrap">
                    <i class="mdi mdi-office-building-outline cw-field-icon"></i>
                    <select v-model="operator.fk_company" class="cw-select" required @change="onCompanyChange">
                      <option :value="null" disabled>Seleziona Azienda...</option>
                      <option v-for="c in companies" :key="c.id" :value="c.id">{{ c.nome }}</option>
                    </select>
                    <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                  </div>
                </div>

                <!-- Squadra Assegnata (Mostrato se NON è autonomo) -->
                <div class="form-group mb-4 text-left" v-if="!operator.is_autonomo">
                  <label class="cw-label">Squadra di appartenenza</label>
                  <div class="cw-select-wrap">
                    <i class="mdi mdi-account-multiple cw-field-icon"></i>
                    <select v-model="operator.fk_team" class="cw-select">
                      <option value="">Nessuna squadra assegnata</option>
                      <option v-for="t in teams" :key="t.id" :value="t.id">{{ t.fullname }}</option>
                    </select>
                    <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                  </div>
                </div>

                <hr class="my-4">

                <!-- ===== SEZIONE SQUADRA AUTONOMA ===== -->
                <div class="form-group mb-4 text-left">
                  <label class="au-checkbox-label font-weight-bold text-dark" for="op_autonomo" style="font-size: 1.1rem;">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      id="op_autonomo"
                      v-model="operator.is_autonomo"
                      @change="updateUsernamePreview"
                    >
                    <span class="au-checkbox-custom"></span>
                    Crea come squadra singola (Lavora autonomamente)
                  </label>
                  <p class="text-muted small ml-4 mt-1">Abilitando questa spunta, verrà generato un account squadra fittizio per permettere all'operatore di effettuare il login e visualizzare i lavori assegnati.</p>
                </div>

                <!-- Dati Squadra (Mostrati solo se is_autonomo è spuntato) -->
                <div class="au-squad-box mb-4 text-left" v-if="operator.is_autonomo">
                  <div class="row">
                    <!-- Commessa -->
                    <div class="col-md-6 form-group mb-3">
                      <label class="cw-label">Commessa *</label>
                      <div class="cw-select-wrap">
                        <i class="mdi mdi-briefcase-outline cw-field-icon"></i>
                        <select v-model="selectedCommessa" class="cw-select" required @change="updateUsernamePreview">
                          <option value="" disabled>Seleziona commessa...</option>
                          <option v-for="c in commesse" :key="c.id" :value="c.id">{{ c.nome }}</option>
                        </select>
                        <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                      </div>
                    </div>

                    <!-- Tipologia Squadra -->
                    <div class="col-md-6 form-group mb-3">
                      <label class="cw-label">Tipologia Squadra *</label>
                      <div class="cw-select-wrap">
                        <i class="mdi mdi-account-hard-hat-outline cw-field-icon"></i>
                        <select v-model="selectedTeamType" class="cw-select" required @change="updateUsernamePreview">
                          <option value="" disabled>Seleziona tipologia...</option>
                          <option v-for="t in filteredTeamTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
                        </select>
                        <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                      </div>
                    </div>
                  </div>

                  <!-- Username Preview -->
                  <div class="au-username-preview mt-2">
                    <i class="mdi mdi-information-outline mr-1 text-primary"></i>
                    Username generato per l'accesso: <strong>{{ teamEmailPreview || 'Compila i campi sopra' }}</strong>
                  </div>
                </div>

                <!-- Danger zone (solo in edit mode) -->
                <div class="au-card au-danger-zone mt-4 text-left" v-if="mode === 'edit'">
                  <div class="cw-section-title text-danger">
                    <span class="cw-step-num au-step-danger">!</span>Zona Pericolosa
                  </div>
                  <div>
                    <button type="button" class="au-btn-danger" @click="deleteOperator()">
                      <i class="mdi mdi-trash-can-outline mr-1"></i> Elimina Operatore
                    </button>
                  </div>
                </div>

                <!-- Footer -->
                <div class="cw-footer mt-4 d-flex align-items-center justify-content-between flex-wrap">
                  <small class="text-muted">
                    <i class="mdi mdi-asterisk text-danger" style="font-size:0.6rem; vertical-align:middle;"></i>
                    Campi obbligatori
                  </small>
                  <div class="d-flex" style="gap:12px;">
                    <button type="button" class="btn btn-light rounded-pill px-4 font-weight-semibold border" @click="mode = 'list'">
                      Annulla
                    </button>
                    <button type="submit" class="cw-btn-submit">
                      <i class="mdi mdi-check-circle-outline mr-1"></i> Salva
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { groupOperatorsByTeam, filterGroups } from "@/utils/operatorGrouping";

export default {
  name: "AdminOperators",
  components: {
    Navbar
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      myCompanyId: parseInt(localStorage.getItem("fk_company")) || null,
      mode: "list", // 'list', 'add', 'edit'
      operators: [],
      companies: [],
      commesse: [],
      activeModules: [],
      allTeamTypes: JSON.parse(localStorage.getItem("teamTypes") || "[]"),
      searchQuery: "",
      teamFilter: "ALL", // 'ALL' = squadre reali + Senza squadra; 'TEAMS' = solo squadre reali
      teams: [],

      // Stato del modale di assegnazione operatori a una squadra
      assignModalOpen: false,
      assignTargetTeam: null,
      assignSelectedIds: [],
      assignSaving: false,
      
      // Form data
      operator: {
        id: null,
        nome: "",
        cognome: "",
        codice_fiscale: "",
        telefono: "",
        email: "",
        qualifica: "",
        costo_orario: null,
        is_attivo: true,
        is_autonomo: false,
        fk_company: null,
        fk_team: ""
      },
      selectedCommessa: "",
      selectedTeamType: "",
      teamEmailPreview: "",
    };
  },

  computed: {
    isDeveloper() {
      return this.tipologia === "D";
    },
    filteredTeamTypes() {
      if (!this.operator || !this.operator.fk_company) {
        return this.allTeamTypes;
      }
      const activeModuleCodes = this.activeModules.map(m => m.codice);
      return this.allTeamTypes.filter(t => !t.module || activeModuleCodes.includes(t.module));
    },
    groupedOperators() {
      return groupOperatorsByTeam(this.operators, this.teams);
    },
    filteredGroups() {
      return filterGroups(this.groupedOperators, {
        search: this.searchQuery,
        teamFilter: this.teamFilter
      });
    },
    hasResults() {
      return this.filteredGroups.length > 0;
    },
    // Candidati per il modale di assegnazione: operatori dipendenti dell'azienda della squadra target.
    assignCandidates() {
      if (!this.assignTargetTeam) return [];
      const companyId = this.assignTargetTeam.fk_company;
      return this.operators.filter(o => {
        if (o.is_autonomo) return false;
        if (companyId != null && o.fk_company != null) return String(o.fk_company) === String(companyId);
        return true;
      });
    }
  },

  mounted() {
    if (this.tipologia !== "B" && this.tipologia !== "D") {
      this.$router.push({ name: "home" });
      return;
    }
    this.loadOperators();
    this.loadCompanies();
    this.loadCommesse(this.isDeveloper ? null : this.myCompanyId);
    this.loadCompanyModules(this.isDeveloper ? null : this.myCompanyId);
    this.loadTeamTypes(this.isDeveloper ? null : this.myCompanyId);
    this.loadTeams(this.isDeveloper ? null : this.myCompanyId);
  },

  methods: {
    loadOperators() {
      this.axios.get("/operators").then(response => {
        this.operators = response.data;
      }).catch(err => {
        console.error("Errore nel caricamento degli operatori", err);
      });
    },

    loadCompanies() {
      if (this.isDeveloper) {
        this.axios.get("/companies").then(response => {
          this.companies = Array.isArray(response.data) ? response.data : [];
        });
      }
    },

    loadTeamTypes(companyId) {
      const defaultTeamTypes = [
        { value: "1", label: "Manutenzione stradale", module: "manutenzione_strade", initials: "MS" },
        { value: "2", label: "Manutenzione aree verdi", module: "verde_pubblico", initials: "MAV" },
        { value: "3", label: "Installazione impianto", module: "illuminazione", initials: "II" },
        { value: "4", label: "Riparazione guasti", module: "illuminazione", initials: "RG" },
        { value: "5", label: "Controllo impianti", module: "illuminazione", initials: "CI" },
        { value: "6", label: "Manutenzione ordinaria", module: "manutenzione_strade", initials: "MO" },
        { value: "7", label: "Gestione emergenza", module: "manutenzione_strade", initials: "GE" },
        { value: "8", label: "Pulizia e sanificazione", module: "pulizia_stradale", initials: "PP" },
        { value: "9", label: "Controllo qualità", module: "manutenzione_strade", initials: "CQ" }
      ];
      if (!companyId) {
        this.allTeamTypes = defaultTeamTypes;
        localStorage.setItem("teamTypes", JSON.stringify(defaultTeamTypes));
        return;
      }
      this.axios.get(`/companies/${companyId}/tipologie-squadra`).then(response => {
        const customTypes = Array.isArray(response.data) ? response.data : [];
        const mappedCustom = customTypes.map(t => ({
          value: String(t.id),
          label: t.nome,
          module: t.module_code || "",
          initials: t.codice || ""
        }));
        const merged = [...defaultTeamTypes, ...mappedCustom];
        this.allTeamTypes = merged;
        localStorage.setItem("teamTypes", JSON.stringify(merged));
      }).catch(err => {
        console.error("Errore recupero tipologie squadra:", err);
      });
    },

    loadCommesse(companyId) {
      if (!companyId) {
        this.commesse = [];
        return;
      }
      this.axios.get(`/companies/${companyId}/commesse`).then(response => {
        this.commesse = Array.isArray(response.data) ? response.data : [];
        if (this.commesse.length > 0 && !this.selectedCommessa) {
          this.selectedCommessa = this.commesse[0].id;
        }
      });
    },

    loadCompanyModules(companyId) {
      if (!companyId) {
        this.activeModules = [];
        return;
      }
      this.axios.get(`/companies/${companyId}/modules`).then(response => {
        this.activeModules = Array.isArray(response.data) ? response.data : [];
      });
    },

    loadTeams(companyId) {
      this.axios.get("/get-users").then((response) => {
        const users = Array.isArray(response.data) ? response.data : [];
        let squadUsers = users.filter(u => this.allTeamTypes.some(t => t.value === u.group));
        if (companyId) {
          squadUsers = squadUsers.filter(u => u.fk_company === companyId);
        }
        this.teams = squadUsers;
      }).catch(err => console.error("Errore recupero squadre", err));
    },

    // ===== Azioni di gruppo (squadra) =====
    openAssignModal(team) {
      this.assignTargetTeam = team;
      this.assignSelectedIds = [];
      this.assignModalOpen = true;

      // Preseleziona i membri correnti dalla fonte autorevole.
      this.axios.get(`/teams/${team.id}/operators`).then(response => {
        const members = Array.isArray(response.data) ? response.data : [];
        this.assignSelectedIds = members.map(o => o.id);
      }).catch(err => {
        console.error("Errore recupero membri squadra", err);
        // Fallback: operatori già presenti nel gruppo calcolato lato client.
        this.assignSelectedIds = this.operators
          .filter(o => o.team_id === team.id)
          .map(o => o.id);
      });
    },

    closeAssignModal() {
      this.assignModalOpen = false;
      this.assignTargetTeam = null;
      this.assignSelectedIds = [];
      this.assignSaving = false;
    },

    saveAssignment() {
      if (!this.assignTargetTeam) return;
      const teamId = this.assignTargetTeam.id;
      this.assignSaving = true;
      this.axios.post(`/teams/${teamId}/operators`, { operator_ids: this.assignSelectedIds }).then(response => {
        if (response.data && response.data.success === false) {
          this.assignSaving = false;
          this.$swal.fire("Errore", response.data.error || "Impossibile aggiornare gli operatori della squadra", "error");
          return;
        }
        this.loadOperators();
        this.loadTeams(this.isDeveloper ? null : this.myCompanyId);
        this.closeAssignModal();
        this.$toast.success("Salvato!", "Composizione della squadra aggiornata.");
      }).catch(err => {
        console.error(err);
        this.assignSaving = false;
        this.$swal.fire("Errore", "Impossibile aggiornare gli operatori della squadra", "error");
      });
    },

    goToBackoffice(team) {
      this.$router.push({ name: "admin-users", query: { editTeam: team.id } });
    },

    onCompanyChange() {
      this.loadCommesse(this.operator.fk_company);
      this.loadCompanyModules(this.operator.fk_company);
      this.loadTeamTypes(this.operator.fk_company);
      this.loadTeams(this.operator.fk_company);
      this.selectedCommessa = "";
      this.updateUsernamePreview();
    },

    setAddMode() {
      const companyId = this.isDeveloper ? null : this.myCompanyId;
      this.operator = {
        id: null,
        nome: "",
        cognome: "",
        codice_fiscale: "",
        telefono: "",
        email: "",
        qualifica: "",
        costo_orario: null,
        is_attivo: true,
        is_autonomo: false,
        fk_company: companyId,
        fk_team: ""
      };
      this.selectedCommessa = "";
      this.selectedTeamType = "";
      this.teamEmailPreview = "";
      
      this.loadCommesse(companyId);
      this.loadCompanyModules(companyId);
      this.loadTeamTypes(companyId);
      this.mode = "add";
    },

    setEditMode(item) {
      this.operator = Object.assign({}, item);
      this.operator.fk_team = item.team_id || "";
      this.selectedCommessa = "";
      this.selectedTeamType = "";
      this.teamEmailPreview = "";

      this.loadCommesse(this.operator.fk_company);
      this.loadCompanyModules(this.operator.fk_company);
      this.loadTeamTypes(this.operator.fk_company);
      
      // Se era autonomo, proviamo a recuperare le informazioni della sua squadra (utente)
      if (this.operator.is_autonomo) {
        // Troviamo il codice utente/squadra associato in squadra_operatori
        // La chiamata GET /teams/xx/operators ci permette di trovare gli operatori della squadra,
        // ma noi vogliamo trovare la squadra dato l'operatore.
        // Recuperiamo tramite GET /get-users e cerchiamo in base al nome
        this.axios.get("/get-users").then(res => {
          const matchingTeam = res.data.find(u => u.fullname === `${this.operator.nome} ${this.operator.cognome}`);
          if (matchingTeam) {
            // Es: C1.mario_rossi.MS
            const parts = matchingTeam.email.split('.');
            this.teamEmailPreview = matchingTeam.email;
            
            // Estrapola commessa (C1 -> 1)
            const cMatch = parts[0].match(/^C(\d+)/);
            if (cMatch) {
              this.selectedCommessa = parseInt(cMatch[1]);
            }
            
            // Estrapola tipo (MS)
            if (parts.length > 2) {
              const initials = parts[2];
              const tType = this.allTeamTypes.find(t => t.initials === initials);
              if (tType) {
                this.selectedTeamType = tType.value;
              }
            }
          }
        });
      }

      this.mode = "edit";
    },

    getGroupInitials(group) {
      const found = this.allTeamTypes.find(t => t.value === group);
      return found ? found.initials : "";
    },

    updateUsernamePreview() {
      if (!this.operator.nome || !this.operator.cognome || !this.selectedCommessa || !this.selectedTeamType) {
        this.teamEmailPreview = "";
        return;
      }
      
      const cleanName = (this.operator.nome + "_" + this.operator.cognome)
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^a-z0-9_]/g, "");

      const initials = this.getGroupInitials(this.selectedTeamType);
      this.teamEmailPreview = `C${this.selectedCommessa}.${cleanName}${initials ? '.' + initials : ''}`;
    },

    saveOperator() {
      if (!this.operator.nome.trim() || !this.operator.cognome.trim()) {
        this.$swal.fire("Attenzione", "Nome e cognome sono obbligatori.", "warning");
        return;
      }

      const payload = {
        nome: this.operator.nome.trim(),
        cognome: this.operator.cognome.trim(),
        codice_fiscale: this.operator.codice_fiscale ? this.operator.codice_fiscale.trim().toUpperCase() : null,
        telefono: this.operator.telefono ? this.operator.telefono.trim() : null,
        email: this.operator.email ? this.operator.email.trim() : null,
        qualifica: this.operator.qualifica ? this.operator.qualifica.trim() : null,
        costo_orario: this.operator.costo_orario,
        is_attivo: this.operator.is_attivo,
        is_autonomo: this.operator.is_autonomo,
        fk_company: this.operator.fk_company,
        fk_team: this.operator.is_autonomo ? null : this.operator.fk_team
      };

      if (payload.is_autonomo) {
        this.updateUsernamePreview();
        if (!this.selectedCommessa || !this.selectedTeamType) {
          this.$swal.fire("Attenzione", "Per gli operatori autonomi è obbligatorio specificare Commessa e Tipologia Squadra.", "warning");
          return;
        }
        payload.team_email = this.teamEmailPreview;
        payload.team_group = this.selectedTeamType;
        payload.team_commessa = this.selectedCommessa;
      }

      const url = this.mode === "add" ? "/operators" : `/operators/${this.operator.id}/update`;
      
      this.axios.post(url, payload).then(response => {
        if (response.data.success) {
          this.$toast.success("Salvato!", "Operatore salvato con successo.");
          this.loadOperators();
          this.mode = "list";
        } else {
          this.$swal.fire("Errore", response.data.error || "Impossibile salvare l'operatore", "error");
        }
      }).catch(err => {
        console.error(err);
        this.$swal.fire("Errore", "Server error", "error");
      });
    },

    deleteOperator() {
      this.$swal.fire({
        title: "Sei sicuro?",
        text: "L'operatore verrà rimosso. Se è di tipo autonomo, verrà eliminata anche la sua utenza mobile.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#1A2238",
        customClass: {
          confirmButton: "roadme-confirm roadme-danger",
          cancelButton: "roadme-cancel"
        },
        confirmButtonText: "Sì, elimina!",
        cancelButtonText: "Annulla"
      }).then(result => {
        if (result.isConfirmed) {
          this.axios.post(`/operators/${this.operator.id}/delete`).then(response => {
            if (response.data.success) {
              this.$toast.success("Eliminato!", "Operatore rimosso con successo.");
              this.loadOperators();
              this.mode = "list";
            } else {
              this.$swal.fire("Errore", response.data.error || "Impossibile eliminare l'operatore", "error");
            }
          }).catch(err => {
            console.error(err);
            this.$swal.fire("Errore", "Server error", "error");
          });
        }
      });
    }
  }
};
</script>

<style scoped>
/* Shared tokens from style.md */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-input:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-disabled { opacity: 0.5; pointer-events: none; }
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* Location tabs reuse */
.cw-location-tabs {
  display: flex; background: #f1f5f9;
  border-radius: 12px; padding: 4px; gap: 2px;
}
.cw-loc-tab {
  flex: 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center; gap: 3px;
  padding: 10px 6px; border: none; border-radius: 9px;
  background: transparent; color: #94a3b8;
  font-size: 0.7rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.04em;
  cursor: pointer; transition: all 0.2s;
}
.cw-loc-tab .mdi { font-size: 1.1rem; }
.cw-loc-tab:hover { background: rgba(255,255,255,0.7); color: #F7931E; }
.cw-loc-tab.active { background: #fff; color: #E07B00; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }

/* Header icon */
.cw-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.cw-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Submit btn */
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45);
  transform: translateY(-1px);
}
.cw-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }

/* Search */
.au-search-wrap {
  position: relative; display: flex; align-items: center;
  background: #f8fafc; border: 1.5px solid #e2e8f0;
  border-radius: 30px; height: 44px; padding: 0 16px 0 38px;
  min-width: 260px; transition: border-color 0.2s;
}
.au-search-wrap:focus-within { border-color: #F7931E; background: #fff; }
.au-search-icon {
  position: absolute; left: 14px; color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.au-search-input {
  border: none; background: transparent; outline: none;
  font-size: 0.9rem; color: #1e293b; width: 100%;
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr {
  border-bottom: 2px solid #f1f5f9;
}
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8;
  background: #f8fafc;
}
.au-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

/* Avatar */
.au-avatar {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.au-avatar .mdi { font-size: 1rem; }
.au-avatar-admin { background: #FEF1E0; color: #F7931E; }
.au-avatar-supervisor { background: #f0fdf4; color: #22c55e; }
.au-avatar-squad { background: #fef9c3; color: #ca8a04; }

/* Role badge */
.au-role-badge {
  display: inline-block; padding: 3px 10px; border-radius: 20px;
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em;
}
.au-role-admin { background: #FEF1E0; color: #E07B00; }
.au-role-supervisor { background: #f0fdf4; color: #16a34a; }
.au-role-squad { background: #fef9c3; color: #92400e; }

/* Action btn */
.au-btn-action {
  display: inline-flex; align-items: center;
  padding: 6px 16px; border-radius: 20px; border: 1.5px solid #e2e8f0;
  background: #fff; color: #F7931E; font-size: 0.8rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-action:hover {
  background: #FEF1E0; border-color: #F7931E;
}

/* Checkbox */
.au-checkbox-label {
  display: flex; align-items: center; gap: 10px;
  font-size: 0.88rem; font-weight: 600; color: #334155;
  cursor: pointer; padding: 10px 14px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; transition: all 0.15s; user-select: none;
}
.au-checkbox-label:hover { border-color: #F5B871; background: #FEF1E0; color: #E07B00; }
.au-checkbox-input {
  position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;
}
.au-checkbox-custom {
  width: 18px; height: 18px; border-radius: 5px;
  border: 2px solid #cbd5e1; background: #fff;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; transition: all 0.15s;
}
.au-checkbox-input:checked + .au-checkbox-custom {
  background: linear-gradient(135deg, #F7931E, #E07B00);
  border-color: #F7931E;
}
.au-checkbox-input:checked + .au-checkbox-custom::after {
  content: '✓'; color: #fff; font-size: 11px; font-weight: 900; line-height: 1;
}
/* Highlight the whole label when selected (does NOT override the custom square) */
.au-checkbox-label:has(.au-checkbox-input:checked) {
  border-color: #F7931E; background: #FEF1E0; color: #E07B00;
}

/* Squad box details */
.au-squad-box {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
}

/* Danger zone */
.au-danger-zone { border: 1.5px solid #fee2e2; background: #fff5f5; }
.au-step-danger { background: linear-gradient(135deg, #ef4444, #b91c1c); }

.au-btn-danger {
  display: inline-flex; align-items: center;
  padding: 8px 18px; border-radius: 20px;
  border: 1.5px solid #fecaca; background: #fff5f5;
  color: #991b1b; font-size: 0.82rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-danger:hover { background: #fee2e2; border-color: #ef4444; }

/* Username preview */
.au-username-preview {
  background: #FEF1E0; border-radius: 8px;
  padding: 8px 12px; font-size: 0.8rem; color: #C96A00;
  border: 1px solid #FBD9AE;
}

/* Grouped view */
.au-group {
  background: #fff; border-radius: 14px;
  border: 1px solid #eef2f7;
  box-shadow: 0 1px 8px rgba(0,0,0,0.04);
  padding: 16px 18px;
}
.au-group-header {
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 6px;
}
.au-group-empty {
  font-size: 0.85rem;
}

/* Assign modal */
.au-modal-overlay {
  position: fixed; inset: 0; z-index: 1050;
  background: rgba(15, 23, 42, 0.45);
  display: flex; align-items: center; justify-content: center;
  padding: 20px;
}
.au-modal {
  width: 100%; max-width: 540px;
}
.au-modal .au-card {
  max-height: 85vh; display: flex; flex-direction: column;
}
.au-modal-body {
  overflow-y: auto; max-height: 50vh;
  display: flex; flex-direction: column;
}

/* Premium Status Badges */
.badge-status-active {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  background-color: #f0fdf4;
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.2);
}
.badge-status-inactive {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.2);
}
</style>
